import { z } from 'zod';

export const statusStatisticsSchema = z.object({
  draft: z.number(),
  open: z.number(),
  toBeApproved: z.number(),
  toBePublished: z.number().optional(),
  pendingAcceptance: z.number().optional(),
  closed: z.number(),
  discarded: z.number(),
  remediationPlanning: z.number(),
  inRemediation: z.number(),
});

export const severityStatisticsSchema = z.object({
  veryHigh: z.number().optional(),
  critical: z.number().optional(),
  high: z.number(),
  medium: z.number(),
  low: z.number(),
  veryLow: z.number().optional(),
  undefined: z.number(),
});

export const statisticsSchema = z
  .object({
    all: z.number(),
  })
  .merge(statusStatisticsSchema)
  .merge(severityStatisticsSchema);

export type Statistics = z.infer<typeof statisticsSchema>;
type SeverityStatistics = z.infer<typeof severityStatisticsSchema>;
type StatusStatistics = z.infer<typeof statusStatisticsSchema>;

export type GetStatistics = {
  total: number;
  status: StatusStatistics;
  severity: SeverityStatistics;
};
